// import { useEffect, useState } from 'react'
// import { useDispatch, useSelector } from 'react-redux'
// import { useLocation, useParams } from 'react-router-dom'
// import { toast } from 'react-toastify'
// import { API_PARAM_STRINGS, COURSE_DRAFT_STATUS_TYPES, TOAST_UTILS } from 'src/consumer/constants'
// import { openInNewTab } from 'src/consumer/helpers/utilFunctions'
// import { isCommonResponseSuccessful } from 'src/mentor/helpers/utilityFunctions'
// import { getDraftByContentId } from 'src/mentor/reducers/courseDraft/services/getDraft/getDraftByContentId'
// import {
//   selectCourseCategories,
//   setCourseCategories,
// } from 'src/mentor/reducers/courses/coursesReducer'
// import { getMPData, postMPDataWithParams } from 'src/mentor/services'
// import MentorHeader from '../MentorHeader'
// import { DRAFTS_API_MAP } from './draftsApis'

export default function EditorListing() {
  // const { courseCategory } = useParams()
  // const [loading, setLoading] = useState(true)
  // const categories = useSelector(selectCourseCategories)
  // const dispatch = useDispatch()
  // async function getCategories() {
  //   const resp = await getMPData('/api/secure/teacher/meta-categories')
  //   if (resp?.status === 200) {
  //     if (resp?.data) {
  //       const filteredMetaCategories = resp.data?.filter((item) => {
  //         return item?.categoryType === 'course'
  //       })
  //       dispatch(setCourseCategories(filteredMetaCategories))
  //     }
  //   }
  //   setLoading(false)
  // }
  // useEffect(() => {
  //   getCategories()
  // }, [])
  // const location = useLocation()
  // const [showDraftsListDialog, setShowDraftsListDialog] = useState(false)
  // const [selectedCourse, setSelectedCourse] = useState(null)
  // async function getActiveDraftForCourseAndNavigateAccordingly(
  //   courseData,
  //   afterSuccessFunction = (draftData, currentRoute) => {},
  // ) {
  //   const tst = toast.loading('Getting active draft')
  //   const currentRoute = `${window.location.origin}${location.pathname}`
  //   const resp = await dispatch(
  //     getDraftByContentId({
  //       contentId: courseData.id,
  //     }),
  //   )
  //     .then(async (resp) => {
  //       let payload = resp.payload
  //       if (!resp?.payload?.id) {
  //         const res = await postMPDataWithParams(DRAFTS_API_MAP.save, {
  //           draft: {
  //             ...resp?.payload,
  //             apiParam: API_PARAM_STRINGS.courseDraft,
  //           },
  //           type: API_PARAM_STRINGS.onlineCourse,
  //         })
  //         if (res.status === 200 && isCommonResponseSuccessful(res.data.code)) {
  //           payload = res.data.data.course
  //         }
  //       }
  //       toast.dismiss(tst)
  //       afterSuccessFunction(payload, currentRoute)
  //     })
  //     .catch((err) => {
  //       toast.dismiss(tst)
  //       toast.error(err.message)
  //     })
  // }
  // async function retractDraftApprovalRequest(draft, refreshFunction) {
  //   const tst = toast.loading('Retracting approval request')
  //   const response = await postMPDataWithParams(
  //     DRAFTS_API_MAP.retractApprovalRequest,
  //     {},
  //     {
  //       draftId: draft?.id,
  //       contentType: API_PARAM_STRINGS.onlineCourse,
  //     },
  //     undefined,
  //     undefined,
  //     undefined,
  //     false,
  //   )
  //   if (response.status === 200 && isCommonResponseSuccessful(response.data.code)) {
  //     refreshFunction()
  //     toast.update(tst, {
  //       render: 'Approval request retracted',
  //       type: toast.TYPE.SUCCESS,
  //       isLoading: false,
  //       autoClose: 2000,
  //       ...TOAST_UTILS,
  //     })
  //   } else {
  //     toast.update(tst, {
  //       render: `Could not retract approval request ${
  //         response?.message || response?.data?.message
  //       }`,
  //       type: toast.TYPE.ERROR,
  //       isLoading: false,
  //       autoClose: 2000,
  //       ...TOAST_UTILS,
  //     })
  //   }
  // }
  // async function viewPublishedCourse(courseData) {
  //   const currentRoute = `${window.location.origin}${location.pathname}`
  //   var poppedDraftRoute = currentRoute.split('/')
  //   poppedDraftRoute.pop()
  //   poppedDraftRoute = poppedDraftRoute.join('/')
  //   openInNewTab(`${poppedDraftRoute}/approved-courses/${courseData.id}?mode=View`)
  // }
  // function handleOpenDraftsListDialog(courseData) {
  //   setSelectedCourse(courseData)
  //   setShowDraftsListDialog(true)
  // }
  // async function onRowClickForMyCoursesListing({ item }) {
  //   viewPublishedCourse(item)
  // }
  // async function requestToUnpublishCourse(courseData, refreshFunction) {
  //   reqToUnpublishOnlineCourseApiCall({
  //     setDisabledActionButtons: () => {},
  //     courseId: courseData.id,
  //     courseCategory,
  //     afterSuccessFunction: (response) => {
  //       refreshFunction()
  //     },
  //   })
  // }
  // // useEffect(() => {
  // //   dispatch(getMentorsListToStore())
  // // }, [])
  // function customActionsForCourses(apiParam, { refresh, onRowClick }) {
  //   return [
  //     {
  //       id: 'edit',
  //       onClick: (courseData) =>
  //         getActiveDraftForCourseAndNavigateAccordingly(courseData, (draftData, currentRoute) => {
  //           openInNewTab(`${currentRoute}/${draftData.id}?mode=Edit`)
  //         }),
  //       label: 'Edit',
  //       showCondition: () => true,
  //     },
  //     {
  //       id: 'view-published',
  //       onClick: (formData) => onRowClickForMyCoursesListing({ item: formData }),
  //       label: 'View Course',
  //       showCondition: () => true,
  //     },
  //     {
  //       id: 'view-drafts',
  //       onClick: handleOpenDraftsListDialog,
  //       // onClick: (courseData) =>
  //       //   getActiveDraftForCourseAndNavigateAccordingly(courseData, (draftData, currentRoute) => {
  //       //     openInNewTab(`${currentRoute}/${draftData.id}/approval-requests`)
  //       //   }),
  //       label: 'View Drafts',
  //       showCondition: () => true,
  //     },
  //     {
  //       id: 'req-unpublish',
  //       onClick: (formData) => requestToUnpublishCourse(formData, refresh),
  //       label: 'Request to Unpublish',
  //       showCondition: (courseData) =>
  //         courseData?.status === 'published' && !courseData?.reqToUnpublish,
  //     },
  //   ]
  // }
  // function openRawDraft(draftData) {
  //   const currentRoute = `${window.location.origin}${location.pathname}`
  //   openInNewTab(`${currentRoute}/${draftData.id}?mode=Edit`)
  // }
  // function customActionsForRawDrafts(apiParam, { refresh, onRowClick }) {
  //   return [
  //     {
  //       id: 'edit',
  //       onClick: (draftData) => {
  //         openRawDraft(draftData)
  //       },
  //       label: 'Edit',
  //       showCondition: (draftData) => {
  //         return draftData?.state !== COURSE_DRAFT_STATUS_TYPES.submittedSoInActive
  //       },
  //     },
  //     {
  //       id: 'retract-approval-req',
  //       onClick: (draftData) => {
  //         retractDraftApprovalRequest(draftData, refresh)
  //       },
  //       label: 'Retract Approval Request',
  //       showCondition: (draftData) => {
  //         return draftData?.state === COURSE_DRAFT_STATUS_TYPES.submittedSoInActive
  //       },
  //     },
  //   ]
  // }
  // return (
  //   <>
  //     <MentorHeader
  //       heading={`My Courses: ${
  //         categories?.find((cat) => {
  //           return cat?.id === courseCategory
  //         })?.title
  //       }`}
  //     />
  //     <div className="d-flex flex-column gap-2 w-100">
  //       <div>
  //         <CustomReactSelect
  //           key={selectedMentor}
  //           value={selectedMentor}
  //           onChangeEvent={(e) => {
  //             setSelectedMentor(e.target.value)
  //             setRefreshCount((prev) => prev + 1)
  //           }}
  //           isLoading={allMentors?.status === 'pending'}
  //           options={[
  //             {
  //               id: 'all',
  //               title: 'All Mentors',
  //             },
  //             ...(allMentors?.data || [])
  //               ?.slice()
  //               ?.filter((mentor) => mentor?.contentCategories?.includes(courseCategory))
  //               ?.sort((a, b) => a.title.localeCompare(b.title)),
  //           ]}
  //           getOptionValue={(optn) => {
  //             return optn?.id
  //           }}
  //           getOptionLabel={(optn) => {
  //             return optn?.title
  //           }}
  //           selectType={selectTypes.string}
  //         />
  //       </div>
  //       <h6>Raw Drafts</h6>
  //       <EntityListingComponent
  //         apiParam={ALL_ENTITY_TYPES_FROM_CONSTANTS.courseDraft}
  //         customActionsOverride={customActionsForRawDrafts}
  //         onRowClickOverride={({ item }) => openRawDraft(item)}
  //         customListingApiParams={{
  //           disabledOnly: false,
  //           'onlineCourse.category': courseCategory,
  //           'onlineCourse.createdFor': selectedMentor === 'all' ? null : selectedMentor,
  //           // draftStates: `${COURSE_DRAFT_STATUS_TYPES.active},${COURSE_DRAFT_STATUS_TYPES.stashed}`,
  //           contentType: ALL_ENTITY_TYPES_FROM_CONSTANTS.onlineCourse,
  //           rawDrafts: true,
  //         }}
  //         forceSize={5}
  //         refreshDataCountFromProps={refreshCount}
  //       />
  //       <h6>Approved Courses</h6>
  //       <EntityListingComponent
  //         apiParam={ALL_ENTITY_TYPES_FROM_CONSTANTS.onlineCourse}
  //         customActionsOverride={customActionsForCourses}
  //         customListingApiParams={{
  //           createdFor: selectedMentor === 'all' ? null : selectedMentor,
  //           category: courseCategory,
  //         }}
  //         onRowClickOverride={onRowClickForMyCoursesListing}
  //         refreshDataCountFromProps={refreshCount}
  //       />
  //       <Dialog
  //         open={showDraftsListDialog}
  //         PaperComponent={GenericListingPageDialogPaper}
  //         onClose={() => {
  //           setShowDraftsListDialog(false)
  //         }}
  //       >
  //         <DialogTitle
  //           sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
  //         >
  //           <span>Drafts of {selectedCourse?.title}</span>
  //           <Fab
  //             color="secondary"
  //             sx={{ boxShadow: 'unset !important' }}
  //             onClick={() => {
  //               setShowDraftsListDialog(false)
  //             }}
  //           >
  //             <Close />
  //           </Fab>
  //         </DialogTitle>
  //         <DialogContent>
  //           <CourseDraftsDialogComponent
  //             courseData={selectedCourse}
  //             retractDraftApprovalRequest={retractDraftApprovalRequest}
  //           />
  //         </DialogContent>
  //       </Dialog>
  //     </div>
  //   </>
  // )
}

// function CourseDraftsDialogComponent({ courseData, retractDraftApprovalRequest }) {
//   const location = useLocation()

//   async function activateStashedDraft(draft, refreshFunction) {
//     const tst = toast.loading('Activating...')
//     const response = await postMPDataWithParams(
//       DRAFTS_API_MAP.activate,
//       {},
//       {
//         draftId: draft?.id,
//         contentType: API_PARAM_STRINGS.onlineCourse,
//       },
//     )
//     if (response.status === 200 && isCommonResponseSuccessful(response.data.code)) {
//       refreshFunction()
//       toast.update(tst, {
//         render: 'Draft activated',
//         type: toast.TYPE.SUCCESS,
//         isLoading: false,
//         autoClose: 2000,
//         ...TOAST_UTILS,
//       })
//     } else {
//       toast.update(tst, {
//         render: `Could not activate draft: ${response?.message || response?.data?.message}`,
//         type: toast.TYPE.ERROR,
//         isLoading: false,
//         autoClose: 2000,
//         ...TOAST_UTILS,
//       })
//     }
//   }

//   function customActions(apiParam, { refresh, onRowClick }) {
//     return [
//       // {
//       //   id: 'view-approval-requests',
//       //   onClick: (draftData) => {
//       //     const currentRoute = `${window.location.origin}${location.pathname}`
//       //     openInNewTab(`${currentRoute}/${draftData.id}/approval-requests`)
//       //   },
//       //   label: 'View Approval Requests',
//       //   showCondition: () => true,
//       // },
//       {
//         id: 'retract-approval-req',
//         onClick: (draftData) => {
//           retractDraftApprovalRequest(draftData, refresh)
//         },
//         label: 'Retract Approval Request',
//         showCondition: (draftData) => {
//           return draftData?.state === COURSE_DRAFT_STATUS_TYPES.submittedSoInActive
//         },
//       },
//       {
//         id: 'activate-stash',
//         onClick: (draftData) => {
//           activateStashedDraft(draftData, refresh)
//         },
//         label: 'Activate',
//         showCondition: (draftData) => {
//           return draftData?.state === COURSE_DRAFT_STATUS_TYPES.stashed
//         },
//       },
//     ]
//   }

//   return (
//     <EntityListingComponent
//       apiParam={ALL_ENTITY_TYPES_FROM_CONSTANTS.courseDraft}
//       customActionsOverride={customActions}
//       customListingApiParams={{
//         contentId: courseData?.id,
//         includeDisabled: false,
//       }}
//       hideAddEntityButton
//       clickableRows={false}
//       // onRowClickOverride={onRowClickForMyCoursesListing}
//     />
//   )
// }
